<template>
  <component
    :is="tag"
    ref="root"
    :class="{
      'slo-field': true,
      'focus-within': focusWithin,
      disabled: disabled
    }"
    v-stack-y:2xs
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'SloField',
  props: {
    disabled: {type: Boolean, default: false},
    tag: {type: String, default: 'label'}
  },
  data() {
    return {
      focusWithin: false
    };
  },
  computed: {
    fieldState() {
      return Object.assign({}, this.$data, {
        disabled: this.$props.disabled
      });
    }
  },
  provide() {
    return {
      fieldState: this.fieldState
    };
  },
  methods: {
    handleFocusIn() {
      this.focusWithin = true;
    },
    handleFocusOut() {
      this.focusWithin = false;
    }
  },
  mounted() {
    this.$refs.root.addEventListener('focusin', this.handleFocusIn);
    this.$refs.root.addEventListener('focusout', this.handleFocusOut);
  },
  willUnmount() {
    this.$refs.root.removeEventListener('focusin', this.handleFocusIn);
    this.$refs.root.addEventListener('focusout', this.handleFocusOut);
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/system';

.slo-field {
  display: flex;
  flex-direction: column;
}

.slo-field.disabled {
  cursor: not-allowed;
}

.slo-field:not(.disabled):hover,
.slo-field:not(.disabled):focus,
.slo-field:not(.disabled):active {
  .slo-input:not(.slo-input--error) {
    border-color: $color-gray-700;
  }

  .slo-label {
    color: $color-gray-900;
  }
}

.slo-field:not(.disabled) {
  .focus-within {
    .slo-input {
      border-color: $color-blue-400;
    }

    .slo-label {
      color: $color-blue-400;
    }
  }
}
</style>
